module.exports = __webpack_public_path__ + "static/media/16.830d3709.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/16.png
// module id = 1257
// module chunks = 0